import { useJointBillServicePeriodListQuery } from "@services/jointBillServices/queries";

export const useCurrentJointBillServicePeriodId = (): number | undefined => {
  const { data: periodList } = useJointBillServicePeriodListQuery();
  return periodList?.[0]?.periods.sort((a, b) => b.periodId - a.periodId)[0]
    ?.periodId;
};
